<div class="dialog-container" fxLayout="column" fxLayoutAlign="">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="header-container">
    <div fxLayout="row" fxLayoutAlign="start center" class="left-header">
      <evc-svg-icon size="lg" [icon]="errorIcon" class="red-icon"></evc-svg-icon>
      <!-- Title -->
      <h2 mat-dialog-title class="dialog-title">{{ 'commonErrorMessageDialog.error' | translate }}</h2>
    </div>

    <evc-nav-button  class="black-icon close-button" id="selected-filter-button" variant="semi" rightIcon="xmark" [mat-dialog-close]="true">
    </evc-nav-button>
  </div>

  <div class="message-container" fxLayout="column" fxLayoutAlign="">
    <p class="message">{{firstMessage}}<br>{{secondMessage}}</p>
  </div>
</div>
